import { render, staticRenderFns } from "./EditarProduto.vue?vue&type=template&id=911c7fca&scoped=true&"
import script from "./EditarProduto.vue?vue&type=script&lang=js&"
export * from "./EditarProduto.vue?vue&type=script&lang=js&"
import style0 from "./EditarProduto.vue?vue&type=style&index=0&id=911c7fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911c7fca",
  null
  
)

export default component.exports